import React from "react";

const MainLoader = () => {
    return (
        <div className="h-[60vh] flex">
            <div className="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default MainLoader;
